import { render, staticRenderFns } from "./H5VerticalNewsImageList.vue?vue&type=template&id=84cb718a&scoped=true"
import script from "./H5VerticalNewsImageList.vue?vue&type=script&lang=js"
export * from "./H5VerticalNewsImageList.vue?vue&type=script&lang=js"
import style0 from "./H5VerticalNewsImageList.vue?vue&type=style&index=0&id=84cb718a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cb718a",
  null
  
)

export default component.exports